import script from "./moreAddress.vue?vue&type=script&setup=true&lang=js"
export * from "./moreAddress.vue?vue&type=script&setup=true&lang=js"

import "./moreAddress.vue?vue&type=style&index=0&id=2000c634&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2000c634"]])

export default __exports__